import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice, createApi } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/redux-injectors";
import { FeedbackState } from "./types";
import { baseQuery, endpoints, formatErrors, HTTP_METHODS } from "utils/api/endpoints";

export const initialState: FeedbackState = {
    isLoading: false,
    error: null,
    data: null,
};

export const api = createApi({
  reducerPath: "feedbackApi",
  baseQuery,
  tagTypes: ["Feedback"],
  endpoints: (builder) => ({
    submitFeedback: builder.mutation<any, any>({
      query: (body) => ({
        url: endpoints.submitFeedback.url,
        method: endpoints.submitFeedback.method,
        body: body,
      }),
      transformResponse: (response: any) => response || [],
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    // Get feedback history
    getFeedbackHistory: builder.query<any, any>({
      query: () => ({
        url: endpoints.submitFeedback.url,
        method: endpoints.submitFeedback.method,
      }),
      transformResponse: (response: any) => response || [],
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }), 
  }),
})

const slice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const { actions: Actions } = slice;

export const useFeedbackSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  
  return {
    actions: slice.actions,
    ...api,
  };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */ 